import React from 'react';

import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { CustomSwiper } from '~/src/components/TariffLine/styled';

interface IProps {
    slideWidth: string,
    children: React.ReactNode,

}

const CardSwiper = ({ slideWidth, children }: IProps) => {
    const isMobile = useMatchMedia('(max-width: 767px)');

    return isMobile
        ? <CustomSwiper
            withoutDots
            withoutArrows={true}
            framePadding={'0 0 8px'}
            slideWidth={slideWidth}
            cellSpacing={0}
        >
            {children}
        </CustomSwiper>
: <>{children}</>;
};

export default CardSwiper;
